import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useStore } from '@tanstack/react-form';
import moment from 'moment';
import { useFieldContext } from '.';

type DateTimeFieldProps = {
  label: React.ReactNode;
  format?: string;
  disableFuture?: boolean;
  disablePast?: boolean;
};

export const DateTimeField = (props: DateTimeFieldProps) => {
  const field = useFieldContext<string | null | undefined>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );

  const dateTimeValue = field.state.value ? moment(field.state.value) : null;

  return (
    <DateTimePicker
      label={props.label}
      value={dateTimeValue}
      onChange={(momentDate) => {
        field.handleChange(momentDate?.format('YYYY-MM-DDTHH:mm:ss') || null);
      }}
      onClose={field.handleBlur}
      format={props.format}
      disableFuture={props.disableFuture}
      disablePast={props.disablePast}
      slotProps={{
        textField: {
          fullWidth: true,
          error:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors.length > 0
              : false,
          helperText:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors
                  .map((error) => error?.message ?? '')
                  .filter(Boolean)
                  .join(', ') || undefined
              : undefined,
        },
      }}
    />
  );
};
